// examples
// https://github.com/gorails-screencasts/infinite-scroll-stimulus-js/blob/master/app/javascript/controllers/infinite_scroll_controller.js
// https://m.signalvnoise.com/how-to-back-to-top-button-without-scroll-events/
// from ias library: update title and url when scrolling through pages
// ias.on('page', (event) => {
//   // update the title
//   document.title = event.title
//   // update the url
//   let state = history.state
//   history.replaceState(state, event.title, event.url)
// })
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'entries', 'pagination', 'loader' ]

  initialize() {
    let options = {
      rootMargin: '200px',
    }
    this.intersectionObserver = new IntersectionObserver(entries => this.processIntersectionEntries(entries), options)
  }

  connect() {
    if (this.hasPaginationTarget) {
      this.intersectionObserver.observe(this.paginationTarget)
      this.paginationTarget.style.visibility = 'hidden'
    }
  }

  disconnect() {
    if (this.hasPaginationTarget) {
      this.intersectionObserver.unobserve(this.paginationTarget)
    }
  }

  processIntersectionEntries(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        this.loadMore()
        this.loaderTarget.classList.remove('d-none')
        this.loaderTarget.classList.add('loader_visible')
      }
    })
  }

  loadMore() {
    let next_page = this.paginationTarget.querySelector("a[rel='next']")
    if (next_page == null) { return }
    let url = next_page.href
    fetch(url)
      .then(response => response.text())
      .then(res => {
        const parser = new DOMParser()
        const full = parser.parseFromString(res, "text/html")
        const entries = full.querySelector("[data-target~='infinite-scroll.entries']").innerHTML
        const pagination = full.querySelector("[data-target~='infinite-scroll.pagination']").innerHTML
        this.entriesTarget.insertAdjacentHTML('beforeend', entries)
        this.loaderTarget.classList.remove('loader_visible')
        this.loaderTarget.classList.add('d-none')
        this.paginationTarget.innerHTML = pagination
        window.observer.observe()
      })
  }

}
